import {
  Companion_getInstance1t0noik4ocb5x as Companion_getInstance,
  LegalDocumentAgreement2jq7u4nlw18u as LegalDocumentAgreement,
} from './databaseModels.mjs';
import {
  properties1qnxlk10mmfrs as properties,
  get_serializableAnnotations132wwdaanmitj as get_serializableAnnotations,
  SerializableProperty3ugfzrmvjw266 as SerializableProperty,
} from '../../../lightning-server-shared/com/lightningkite/serialization/SerializableProperty.mjs';
import { THROW_CCE2g6jy02ryeudk as THROW_CCE } from '../../../kotlin-kotlin-stdlib/kotlin/hacks.mjs';
import { GeneratedSerializer1f7t7hssdd2ws as GeneratedSerializer } from '../../../kotlinx-serialization-kotlinx-serialization-core/kotlinx/serialization/internal/PluginHelperInterfaces.mjs';
import { isInterface3d6p8outrmvmk as isInterface } from '../../../kotlin-kotlin-stdlib/kotlin/js/typeCheckUtils.mjs';
import { KSerializerzf77vz1967fq as KSerializer } from '../../../kotlinx-serialization-kotlinx-serialization-core/kotlinx/serialization/KSerializer.mjs';
import { lazy2hsh8ze7j6ikd as lazy } from '../../../kotlin-kotlin-stdlib/kotlin/kotlin.mjs';
import { KProperty1ca4yb4wlo496 as KProperty1 } from '../../../kotlin-kotlin-stdlib/kotlin/reflect/KPropertyJs.mjs';
import { getPropertyCallableRef3hckxc0xueiaj as getPropertyCallableRef } from '../../../kotlin-kotlin-stdlib/kotlin/js/reflectRuntime.mjs';
import { VOID3gxj6tk5isa35 as VOID } from '../../../kotlin-kotlin-stdlib/kotlin/js/void.mjs';
import {
  UUID21wrnrlmk5y1y as UUID,
  Companion_getInstance3n9as6ds1py67 as Companion_getInstance_0,
} from '../../../lightning-server-shared/com/lightningkite/UUID.js.mjs';
import { protoOf180f3jzyo7rfj as protoOf } from '../../../kotlin-kotlin-stdlib/kotlin/js/coreRuntime.mjs';
import { initMetadataForObject1cxne3s9w65el as initMetadataForObject } from '../../../kotlin-kotlin-stdlib/kotlin/js/metadataUtils.mjs';
import { AccessInfoj60d6hx1qs8r as AccessInfo } from './supportModels.mjs';
//region block: imports
//endregion
//region block: pre-declaration
//endregion
function get_contractor(_this__u8e3s4) {
  return _this__u8e3s4.prop(LegalDocumentAgreement_contractor_getInstance());
}
function get_user(_this__u8e3s4) {
  return _this__u8e3s4.prop(LegalDocumentAgreement_user_getInstance());
}
function get_document(_this__u8e3s4) {
  return _this__u8e3s4.prop(LegalDocumentAgreement_document_getInstance());
}
function get_accessInfo(_this__u8e3s4) {
  return _this__u8e3s4.prop(LegalDocumentAgreement_accessInfo_getInstance());
}
function prepareLegalDocumentAgreementFields() {
  // Inline function 'kotlin.arrayOf' call
  // Inline function 'kotlin.js.unsafeCast' call
  // Inline function 'kotlin.js.asDynamic' call
  var props = [LegalDocumentAgreement__id_getInstance(), LegalDocumentAgreement_accessInfo_getInstance(), LegalDocumentAgreement_contractor_getInstance(), LegalDocumentAgreement_document_getInstance(), LegalDocumentAgreement_user_getInstance()];
  var tmp = Companion_getInstance().k2a();
  properties(tmp, (it) => props);
}
function LegalDocumentAgreement_contractor$name$delegate$lambda() {
  return Companion_getInstance().k2a().az().v11(2);
}
function LegalDocumentAgreement_contractor$_get_name_$ref_m8ycln() {
  return (p0) => p0.i20();
}
function LegalDocumentAgreement_contractor$serializer$delegate$lambda() {
  var tmp = Companion_getInstance().k2a();
  var tmp_0 = (isInterface(tmp, GeneratedSerializer()) ? tmp : THROW_CCE()).r1b()[2];
  return isInterface(tmp_0, KSerializer()) ? tmp_0 : THROW_CCE();
}
function LegalDocumentAgreement_contractor$_get_serializer_$ref_euwlhq() {
  return (p0) => p0.h2j();
}
function LegalDocumentAgreement_contractor$annotations$delegate$lambda() {
  return Companion_getInstance().k2a().az().x11(2);
}
function LegalDocumentAgreement_contractor$_get_annotations_$ref_ibp3w6() {
  return (p0) => p0.bz();
}
var LegalDocumentAgreement_contractorClass;
function LegalDocumentAgreement_contractor() {
  if (LegalDocumentAgreement_contractorClass === VOID) {
    class $ {
      constructor() {
        LegalDocumentAgreement_contractor_instance = this;
        var tmp = this;
        tmp.k6d_1 = lazy(LegalDocumentAgreement_contractor$name$delegate$lambda);
        var tmp_0 = this;
        tmp_0.l6d_1 = lazy(LegalDocumentAgreement_contractor$serializer$delegate$lambda);
        var tmp_1 = this;
        tmp_1.m6d_1 = lazy(LegalDocumentAgreement_contractor$annotations$delegate$lambda);
        this.n6d_1 = null;
        this.o6d_1 = 'null';
      }
      i20() {
        var tmp0 = this.k6d_1;
        var tmp = KProperty1();
        // Inline function 'kotlin.getValue' call
        getPropertyCallableRef('name', 1, tmp, LegalDocumentAgreement_contractor$_get_name_$ref_m8ycln(), null);
        return tmp0.f2();
      }
      p6d(receiver) {
        return receiver.s6d_1;
      }
      k2j(receiver) {
        return this.p6d(receiver instanceof LegalDocumentAgreement() ? receiver : THROW_CCE());
      }
      v6d(receiver, value) {
        return receiver.w6d(VOID, VOID, value);
      }
      n2j(receiver, value) {
        var tmp = receiver instanceof LegalDocumentAgreement() ? receiver : THROW_CCE();
        return this.v6d(tmp, (value == null ? true : value instanceof UUID()) ? value : THROW_CCE());
      }
      h2j() {
        var tmp0 = this.l6d_1;
        var tmp = KProperty1();
        // Inline function 'kotlin.getValue' call
        getPropertyCallableRef('serializer', 1, tmp, LegalDocumentAgreement_contractor$_get_serializer_$ref_euwlhq(), null);
        return tmp0.f2();
      }
      bz() {
        var tmp0 = this.m6d_1;
        var tmp = KProperty1();
        // Inline function 'kotlin.getValue' call
        getPropertyCallableRef('annotations', 1, tmp, LegalDocumentAgreement_contractor$_get_annotations_$ref_ibp3w6(), null);
        return tmp0.f2();
      }
    }
    protoOf($).o2j = get_serializableAnnotations;
    initMetadataForObject($, 'LegalDocumentAgreement_contractor', VOID, VOID, [SerializableProperty()]);
    LegalDocumentAgreement_contractorClass = $;
  }
  return LegalDocumentAgreement_contractorClass;
}
var LegalDocumentAgreement_contractor_instance;
function LegalDocumentAgreement_contractor_getInstance() {
  if (LegalDocumentAgreement_contractor_instance === VOID)
    new (LegalDocumentAgreement_contractor())();
  return LegalDocumentAgreement_contractor_instance;
}
function LegalDocumentAgreement_user$name$delegate$lambda() {
  return Companion_getInstance().k2a().az().v11(4);
}
function LegalDocumentAgreement_user$_get_name_$ref_wlxdep() {
  return (p0) => p0.i20();
}
function LegalDocumentAgreement_user$serializer$delegate$lambda() {
  var tmp = Companion_getInstance().k2a();
  var tmp_0 = (isInterface(tmp, GeneratedSerializer()) ? tmp : THROW_CCE()).r1b()[4];
  return isInterface(tmp_0, KSerializer()) ? tmp_0 : THROW_CCE();
}
function LegalDocumentAgreement_user$_get_serializer_$ref_v271bs() {
  return (p0) => p0.h2j();
}
function LegalDocumentAgreement_user$annotations$delegate$lambda() {
  return Companion_getInstance().k2a().az().x11(4);
}
function LegalDocumentAgreement_user$_get_annotations_$ref_ndwcy4() {
  return (p0) => p0.bz();
}
var LegalDocumentAgreement_userClass;
function LegalDocumentAgreement_user() {
  if (LegalDocumentAgreement_userClass === VOID) {
    class $ {
      constructor() {
        LegalDocumentAgreement_user_instance = this;
        var tmp = this;
        tmp.x6d_1 = lazy(LegalDocumentAgreement_user$name$delegate$lambda);
        var tmp_0 = this;
        tmp_0.y6d_1 = lazy(LegalDocumentAgreement_user$serializer$delegate$lambda);
        var tmp_1 = this;
        tmp_1.z6d_1 = lazy(LegalDocumentAgreement_user$annotations$delegate$lambda);
        this.a6e_1 = null;
        this.b6e_1 = 'null';
      }
      i20() {
        var tmp0 = this.x6d_1;
        var tmp = KProperty1();
        // Inline function 'kotlin.getValue' call
        getPropertyCallableRef('name', 1, tmp, LegalDocumentAgreement_user$_get_name_$ref_wlxdep(), null);
        return tmp0.f2();
      }
      p6d(receiver) {
        return receiver.u6d_1;
      }
      k2j(receiver) {
        return this.p6d(receiver instanceof LegalDocumentAgreement() ? receiver : THROW_CCE());
      }
      v6d(receiver, value) {
        return receiver.w6d(VOID, VOID, VOID, VOID, value);
      }
      n2j(receiver, value) {
        var tmp = receiver instanceof LegalDocumentAgreement() ? receiver : THROW_CCE();
        return this.v6d(tmp, (value == null ? true : value instanceof UUID()) ? value : THROW_CCE());
      }
      h2j() {
        var tmp0 = this.y6d_1;
        var tmp = KProperty1();
        // Inline function 'kotlin.getValue' call
        getPropertyCallableRef('serializer', 1, tmp, LegalDocumentAgreement_user$_get_serializer_$ref_v271bs(), null);
        return tmp0.f2();
      }
      bz() {
        var tmp0 = this.z6d_1;
        var tmp = KProperty1();
        // Inline function 'kotlin.getValue' call
        getPropertyCallableRef('annotations', 1, tmp, LegalDocumentAgreement_user$_get_annotations_$ref_ndwcy4(), null);
        return tmp0.f2();
      }
    }
    protoOf($).o2j = get_serializableAnnotations;
    initMetadataForObject($, 'LegalDocumentAgreement_user', VOID, VOID, [SerializableProperty()]);
    LegalDocumentAgreement_userClass = $;
  }
  return LegalDocumentAgreement_userClass;
}
var LegalDocumentAgreement_user_instance;
function LegalDocumentAgreement_user_getInstance() {
  if (LegalDocumentAgreement_user_instance === VOID)
    new (LegalDocumentAgreement_user())();
  return LegalDocumentAgreement_user_instance;
}
function LegalDocumentAgreement_document$name$delegate$lambda() {
  return Companion_getInstance().k2a().az().v11(3);
}
function LegalDocumentAgreement_document$_get_name_$ref_fhzimn() {
  return (p0) => p0.i20();
}
function LegalDocumentAgreement_document$serializer$delegate$lambda() {
  var tmp = Companion_getInstance().k2a();
  var tmp_0 = (isInterface(tmp, GeneratedSerializer()) ? tmp : THROW_CCE()).r1b()[3];
  return isInterface(tmp_0, KSerializer()) ? tmp_0 : THROW_CCE();
}
function LegalDocumentAgreement_document$_get_serializer_$ref_7z2rfc() {
  return (p0) => p0.h2j();
}
function LegalDocumentAgreement_document$annotations$delegate$lambda() {
  return Companion_getInstance().k2a().az().x11(3);
}
function LegalDocumentAgreement_document$_get_annotations_$ref_ktdj6k() {
  return (p0) => p0.bz();
}
var LegalDocumentAgreement_documentClass;
function LegalDocumentAgreement_document() {
  if (LegalDocumentAgreement_documentClass === VOID) {
    class $ {
      constructor() {
        LegalDocumentAgreement_document_instance = this;
        var tmp = this;
        tmp.c6e_1 = lazy(LegalDocumentAgreement_document$name$delegate$lambda);
        var tmp_0 = this;
        tmp_0.d6e_1 = lazy(LegalDocumentAgreement_document$serializer$delegate$lambda);
        var tmp_1 = this;
        tmp_1.e6e_1 = lazy(LegalDocumentAgreement_document$annotations$delegate$lambda);
      }
      i20() {
        var tmp0 = this.c6e_1;
        var tmp = KProperty1();
        // Inline function 'kotlin.getValue' call
        getPropertyCallableRef('name', 1, tmp, LegalDocumentAgreement_document$_get_name_$ref_fhzimn(), null);
        return tmp0.f2();
      }
      p6d(receiver) {
        return receiver.t6d_1;
      }
      k2j(receiver) {
        return this.p6d(receiver instanceof LegalDocumentAgreement() ? receiver : THROW_CCE());
      }
      f6e(receiver, value) {
        return receiver.w6d(VOID, VOID, VOID, value);
      }
      n2j(receiver, value) {
        var tmp = receiver instanceof LegalDocumentAgreement() ? receiver : THROW_CCE();
        return this.f6e(tmp, value instanceof UUID() ? value : THROW_CCE());
      }
      h2j() {
        var tmp0 = this.d6e_1;
        var tmp = KProperty1();
        // Inline function 'kotlin.getValue' call
        getPropertyCallableRef('serializer', 1, tmp, LegalDocumentAgreement_document$_get_serializer_$ref_7z2rfc(), null);
        return tmp0.f2();
      }
      bz() {
        var tmp0 = this.e6e_1;
        var tmp = KProperty1();
        // Inline function 'kotlin.getValue' call
        getPropertyCallableRef('annotations', 1, tmp, LegalDocumentAgreement_document$_get_annotations_$ref_ktdj6k(), null);
        return tmp0.f2();
      }
    }
    protoOf($).o2j = get_serializableAnnotations;
    initMetadataForObject($, 'LegalDocumentAgreement_document', VOID, VOID, [SerializableProperty()]);
    LegalDocumentAgreement_documentClass = $;
  }
  return LegalDocumentAgreement_documentClass;
}
var LegalDocumentAgreement_document_instance;
function LegalDocumentAgreement_document_getInstance() {
  if (LegalDocumentAgreement_document_instance === VOID)
    new (LegalDocumentAgreement_document())();
  return LegalDocumentAgreement_document_instance;
}
function LegalDocumentAgreement_accessInfo$name$delegate$lambda() {
  return Companion_getInstance().k2a().az().v11(1);
}
function LegalDocumentAgreement_accessInfo$_get_name_$ref_9fayjc() {
  return (p0) => p0.i20();
}
function LegalDocumentAgreement_accessInfo$serializer$delegate$lambda() {
  var tmp = Companion_getInstance().k2a();
  var tmp_0 = (isInterface(tmp, GeneratedSerializer()) ? tmp : THROW_CCE()).r1b()[1];
  return isInterface(tmp_0, KSerializer()) ? tmp_0 : THROW_CCE();
}
function LegalDocumentAgreement_accessInfo$_get_serializer_$ref_2evp3j() {
  return (p0) => p0.h2j();
}
function LegalDocumentAgreement_accessInfo$annotations$delegate$lambda() {
  return Companion_getInstance().k2a().az().x11(1);
}
function LegalDocumentAgreement_accessInfo$_get_annotations_$ref_jvvmkt() {
  return (p0) => p0.bz();
}
var LegalDocumentAgreement_accessInfoClass;
function LegalDocumentAgreement_accessInfo() {
  if (LegalDocumentAgreement_accessInfoClass === VOID) {
    class $ {
      constructor() {
        LegalDocumentAgreement_accessInfo_instance = this;
        var tmp = this;
        tmp.g6e_1 = lazy(LegalDocumentAgreement_accessInfo$name$delegate$lambda);
        var tmp_0 = this;
        tmp_0.h6e_1 = lazy(LegalDocumentAgreement_accessInfo$serializer$delegate$lambda);
        var tmp_1 = this;
        tmp_1.i6e_1 = lazy(LegalDocumentAgreement_accessInfo$annotations$delegate$lambda);
      }
      i20() {
        var tmp0 = this.g6e_1;
        var tmp = KProperty1();
        // Inline function 'kotlin.getValue' call
        getPropertyCallableRef('name', 1, tmp, LegalDocumentAgreement_accessInfo$_get_name_$ref_9fayjc(), null);
        return tmp0.f2();
      }
      p6d(receiver) {
        return receiver.r6d_1;
      }
      k2j(receiver) {
        return this.p6d(receiver instanceof LegalDocumentAgreement() ? receiver : THROW_CCE());
      }
      j6e(receiver, value) {
        return receiver.w6d(VOID, value);
      }
      n2j(receiver, value) {
        var tmp = receiver instanceof LegalDocumentAgreement() ? receiver : THROW_CCE();
        return this.j6e(tmp, value instanceof AccessInfo() ? value : THROW_CCE());
      }
      h2j() {
        var tmp0 = this.h6e_1;
        var tmp = KProperty1();
        // Inline function 'kotlin.getValue' call
        getPropertyCallableRef('serializer', 1, tmp, LegalDocumentAgreement_accessInfo$_get_serializer_$ref_2evp3j(), null);
        return tmp0.f2();
      }
      bz() {
        var tmp0 = this.i6e_1;
        var tmp = KProperty1();
        // Inline function 'kotlin.getValue' call
        getPropertyCallableRef('annotations', 1, tmp, LegalDocumentAgreement_accessInfo$_get_annotations_$ref_jvvmkt(), null);
        return tmp0.f2();
      }
    }
    protoOf($).o2j = get_serializableAnnotations;
    initMetadataForObject($, 'LegalDocumentAgreement_accessInfo', VOID, VOID, [SerializableProperty()]);
    LegalDocumentAgreement_accessInfoClass = $;
  }
  return LegalDocumentAgreement_accessInfoClass;
}
var LegalDocumentAgreement_accessInfo_instance;
function LegalDocumentAgreement_accessInfo_getInstance() {
  if (LegalDocumentAgreement_accessInfo_instance === VOID)
    new (LegalDocumentAgreement_accessInfo())();
  return LegalDocumentAgreement_accessInfo_instance;
}
function LegalDocumentAgreement__id$name$delegate$lambda() {
  return Companion_getInstance().k2a().az().v11(0);
}
function LegalDocumentAgreement__id$_get_name_$ref_s2b536() {
  return (p0) => p0.i20();
}
function LegalDocumentAgreement__id$serializer$delegate$lambda() {
  var tmp = Companion_getInstance().k2a();
  var tmp_0 = (isInterface(tmp, GeneratedSerializer()) ? tmp : THROW_CCE()).r1b()[0];
  return isInterface(tmp_0, KSerializer()) ? tmp_0 : THROW_CCE();
}
function LegalDocumentAgreement__id$_get_serializer_$ref_aki0bp() {
  return (p0) => p0.h2j();
}
function LegalDocumentAgreement__id$annotations$delegate$lambda() {
  return Companion_getInstance().k2a().az().x11(0);
}
function LegalDocumentAgreement__id$_get_annotations_$ref_becxah() {
  return (p0) => p0.bz();
}
var LegalDocumentAgreement__idClass;
function LegalDocumentAgreement__id() {
  if (LegalDocumentAgreement__idClass === VOID) {
    class $ {
      constructor() {
        LegalDocumentAgreement__id_instance = this;
        var tmp = this;
        tmp.k6e_1 = lazy(LegalDocumentAgreement__id$name$delegate$lambda);
        var tmp_0 = this;
        tmp_0.l6e_1 = lazy(LegalDocumentAgreement__id$serializer$delegate$lambda);
        var tmp_1 = this;
        tmp_1.m6e_1 = lazy(LegalDocumentAgreement__id$annotations$delegate$lambda);
        this.n6e_1 = Companion_getInstance_0().k2p();
        this.o6e_1 = 'UUID.random()';
      }
      i20() {
        var tmp0 = this.k6e_1;
        var tmp = KProperty1();
        // Inline function 'kotlin.getValue' call
        getPropertyCallableRef('name', 1, tmp, LegalDocumentAgreement__id$_get_name_$ref_s2b536(), null);
        return tmp0.f2();
      }
      p6d(receiver) {
        return receiver.q6d_1;
      }
      k2j(receiver) {
        return this.p6d(receiver instanceof LegalDocumentAgreement() ? receiver : THROW_CCE());
      }
      f6e(receiver, value) {
        return receiver.w6d(value);
      }
      n2j(receiver, value) {
        var tmp = receiver instanceof LegalDocumentAgreement() ? receiver : THROW_CCE();
        return this.f6e(tmp, value instanceof UUID() ? value : THROW_CCE());
      }
      h2j() {
        var tmp0 = this.l6e_1;
        var tmp = KProperty1();
        // Inline function 'kotlin.getValue' call
        getPropertyCallableRef('serializer', 1, tmp, LegalDocumentAgreement__id$_get_serializer_$ref_aki0bp(), null);
        return tmp0.f2();
      }
      bz() {
        var tmp0 = this.m6e_1;
        var tmp = KProperty1();
        // Inline function 'kotlin.getValue' call
        getPropertyCallableRef('annotations', 1, tmp, LegalDocumentAgreement__id$_get_annotations_$ref_becxah(), null);
        return tmp0.f2();
      }
    }
    protoOf($).o2j = get_serializableAnnotations;
    initMetadataForObject($, 'LegalDocumentAgreement__id', VOID, VOID, [SerializableProperty()]);
    LegalDocumentAgreement__idClass = $;
  }
  return LegalDocumentAgreement__idClass;
}
var LegalDocumentAgreement__id_instance;
function LegalDocumentAgreement__id_getInstance() {
  if (LegalDocumentAgreement__id_instance === VOID)
    new (LegalDocumentAgreement__id())();
  return LegalDocumentAgreement__id_instance;
}
//region block: exports
export {
  get_accessInfo as get_accessInfo34u27j9iv1ssd,
  get_contractor as get_contractor1xz81jdndzal8,
  get_document as get_documentr6hzirewxd26,
  prepareLegalDocumentAgreementFields as prepareLegalDocumentAgreementFields36049zp6jp0m0,
  get_user as get_user1oq3bclwp0mza,
};
//endregion

//# sourceMappingURL=LegalDocumentAgreementFields.mjs.map
